import React, { useCallback } from 'react'

import { WithPages } from 'data/wrappers/WithPagesComponent'

export const withPages = (Child) => (props) => {
    const fn = useCallback((stackProps) => <Child {...stackProps} {...props} />, [props])
    return <WithPages>{fn}</WithPages>
}
